import { render, staticRenderFns } from "./GameStatisticsItem.vue?vue&type=template&id=0a675f70&scoped=true&"
import script from "./GameStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./GameStatisticsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a675f70",
  null
  
)

export default component.exports